// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import InstantSearch from 'vue-instantsearch'
import VueNoty from 'vuejs-noty'
var infiniteScroll =  require('vue-infinite-scroll');

Vue.config.productionTip = false

Vue.use(infiniteScroll)
Vue.use(InstantSearch)
Vue.use(VueNoty, {
  timeout: 2000,
  progressBar: false,
  layout: 'topRight',
  theme: 'metroui',
  animation: {
	open: 'animated fadeIn', // Animate.css class names
	close: 'animated fadeOut' // Animate.css class names
  }
})

Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.prototype.$globals = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js